// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import "es6-promise/auto";
import "babel-polyfill";
import Vue from 'vue';
import App from './App';
import router from './router';
import store from './store';
import growingIo from './library/growingio';
import tips from './components/tips/main';
import login from './components/login/login';
import api from './api/';
import './scss/common.scss';
import './directives';
import localStorageHelper from './library/localStorageHelper';
import VuePreview from 'vue-preview'
import {setScanPay} from './library/scanPayPoint'
import cdnAssets from './plugins/cdnAssets'
import VueLazyload from 'vue-lazyload'

Vue.use(cdnAssets)
Vue.use(VueLazyload)
Vue.directive('gioets', growingIo.ETS);

window.entryUrl = window.location.href.split('#')[0]


try {
//扫码支付埋点
  setScanPay();
} catch (e) {
  console.log(e)
}

if (process.env.NODE_ENV == 'development') {
  require('../mock/mock');
}
Vue.config.productionTip = false;

function formatComponentName(vm) {
  if (vm.$root === vm) return 'root';

  var name = vm._isVue ? (vm.$options && vm.$options.name) || (vm.$options && vm.$options._componentTag) : vm.name;
  return (name ? 'component <' + name + '>' : 'anonymous component') + (vm._isVue && vm.$options && vm.$options.__file ? ' at ' + (vm.$options && vm.$options.__file) : '');

}

Vue.config.errorHandler = function (err, vm, info) {
  var componentName = formatComponentName(vm);
  var propsData = vm.$options && vm.$options.propsData;
  var Monitor = window.Monitor;
  if (Monitor && Monitor.Error && Monitor.Error.notifyError) {
    Monitor.Error.notifyError(err, {
      metaData: {
        componentName: componentName,
        propsData: propsData,
        info: info
      }
    });
  }
};

Vue.prototype.$ptr = function (px) {
  return px / (375 / 320) / 20 + 'rem';
};
Vue.prototype.$api = api;
Vue.prototype.$localStorage = localStorageHelper;
Vue.prototype.$tips = tips;
Vue.prototype.$login = login;
Vue.prototype.authorize = store.getters.authorize;
if(window.isRealAuthState) {
  store.getters.authorize({auth: false});
}
Vue.use(require('vue-wechat-title'));
Vue.use(VuePreview, {
  mainClass: 'pswp--minimal--dark',
  barsSize: {top: 0, bottom: 0},
  captionEl: false,
  fullscreenEl: false,
  shareEl: false,
  bgOpacity: 0.85,
  tapToClose: true,
  tapToToggleControls: false
});

store.dispatch('setDemotionSwitch').then(() => {
  store.dispatch('fetchCityList').then(() => {

    new Vue({
      el: '#app',
      router,
      store,
      template: '<App/>',
      components: {App}
    });
  });
}).catch(() => {
  store.commit('setDemotionSwitch', false)
  store.dispatch('fetchCityList').then(() => {

    new Vue({
      el: '#app',
      router,
      store,
      template: '<App/>',
      components: {App}
    });
  });
})



// WEBPACK FOOTER //
// ./src/main.js